import { Badge } from '@/common-utils/components/ui/badge';
import ICONS from '@/common-utils/enums/icons';
import Entity from '../../../entity/Entity';
import { Separator } from '@/common-utils/components/ui/separator';
import Icon from '../../../icon/Icon';
import PropTypes from 'prop-types';
import { EventBus } from 'use-event-bus-hook';
import DATA_TABLE_EVENT_BUS_NAMES from '../../enums/DataTableEventBusNames';

/**
 *
 * @param {Object} props
 * @param {Function} props.removeFilter
 * @param {Function} props.removeFilters
 * @param {Object} props.displayedValue
 * @param {string} props.filterKey
 * @param {string} props.namespace
 * @param {string} props.entity
 * @param {string} props.filtersEventName
 * @returns {JSX} FilterBadge Component
 */
function FilterBadge({ displayedValue, filterKey, removeFilter, removeFilters, namespace, entity, filtersEventName }) {

    const dataValues = (array, index, object = {}) => {
        if (index < array.length) {
            object[`value${index}`] = array[index];
            dataValues(array, index + 1, object);
        }
        return object;
    };

    return (
        <Badge
            variant='gray'
            className='flex items-center gap-1 cursor-pointer hover:bg-gray-200 bg-white border border-gray-200'
            onClick={() => {
                EventBus.emit(DATA_TABLE_EVENT_BUS_NAMES.UPDATE_FILTER, { columnId: filterKey, filterValue: displayedValue, filterEventName: filtersEventName });
            }}
        >
            <>
                <Icon icon={ICONS.CLOSE} className={'rounded-full bg-gray-500 text-gray-100 mr-1 !text-base h-4 w-4 !flex items-center'} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (Array.isArray(filterKey)) {
                        removeFilters(filterKey);
                    } else {
                        removeFilter(filterKey);
                    }
                }} />
                <Entity
                    entity={entity}
                    namespace={namespace}
                    className={'font-semibold'}
                />
                <Separator orientation='vertical' />
                <Entity
                    entity={displayedValue.entity ?? displayedValue.filterValue}
                    namespace={displayedValue.namespace}
                    data={Array.isArray(displayedValue.filterValue) ?
                        dataValues(displayedValue.filterValue, 0) :
                        { value: displayedValue.filterValue }
                    }
                />
            </>
        </Badge>

    );
}

FilterBadge.propTypes = {
    displayedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    filterKey: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    removeFilter: PropTypes.func.isRequired,
    removeFilters: PropTypes.func.isRequired,
    namespace: PropTypes.string,
    entity: PropTypes.string,
    filtersEventName: PropTypes.string
};

export default FilterBadge;